import React, { useEffect, useState } from "react";
import styled from "styled-components";

const PetalBackground = () => {
  const [petals, setPetals] = useState<JSX.Element[]>([]);

  useEffect(() => {
    const interval = setInterval(() => {
      const size = Math.random() * 4 + 3;
      const left = Math.random() * 90;
      const duration = Math.random() * 10 + 40;
      const swayDuration = Math.random() * 4 + 2;
      const imgSrc = Math.floor(Math.random() * 3);

      const newSnowflake = (
        <img
          key={Math.random()}
          className="petal"
          style={{
            left: `${left}%`,
            animation: `fall ${duration}s linear, sway ${swayDuration}s ease-in-out infinite alternate`,
            width: `${size}%`,
            height: `${size}%`,
          }}
          // src={
          //   imgSrc === 0
          //     ? `${process.env.PUBLIC_URL}/knockknock/svg/event/tree.svg`
          //     : imgSrc === 1
          //     ? `${process.env.PUBLIC_URL}/knockknock/svg/event/snowman.svg`
          //     : `${process.env.PUBLIC_URL}/knockknock/svg/event/santa_hat.svg`
          // }
          src={`${process.env.PUBLIC_URL}/knockknock/svg/event/blossom02.svg`}
          alt="petal"
        />
      );

      setPetals((prev) => [...prev, newSnowflake]);

      setTimeout(() => {
        setPetals((prev) => prev.slice(1));
      }, duration * 1200);
    }, 1500);

    return () => clearInterval(interval);
  }, []);

  return (
    <Style>
      <div className="background">{petals}</div>
    </Style>
  );
};

export default PetalBackground;

const Style = styled.div`
  .background {
    width: 100vw;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: -40px;
    opacity: 0.9;
    /* background: linear-gradient(0deg, #333, rgb(108, 113, 164)); */
    z-index: 10;
    pointer-events: none;
  }
  img.petal {
    position: absolute;
    top: -50px;
    opacity: 0.9;
    z-index: 10;
    pointer-events: none;
  }
  @keyframes fall {
    0% {
      top: -50px;
    }
    100% {
      top: 110%;
    }
  }

  @keyframes sway {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(30vw);
    }
  }
`;
